/**
 * The one container primitive. `actions` is deliberately part of the contract
 * even though v1 ships no mutations — v2 action buttons drop into that slot
 * without touching any panel body.
 */
export function Panel({ title, subtitle, actions, footer, children, className = '', id }) {
  return (
    <section className={`panel ${className}`.trim()} id={id} aria-labelledby={id ? `${id}-title` : undefined}>
      {title ? (
        <header className="panel__head">
          <div className="panel__heading">
            <h2 className="panel__title" id={id ? `${id}-title` : undefined}>
              {title}
            </h2>
            {subtitle ? <p className="panel__subtitle">{subtitle}</p> : null}
          </div>
          {actions ? <div className="panel__actions">{actions}</div> : null}
        </header>
      ) : null}
      <div className="panel__body">{children}</div>
      {footer ? <footer className="panel__foot">{footer}</footer> : null}
    </section>
  );
}

/** Label/value rows. Values that come from the machine wear the mono face. */
export function DefinitionList({ items }) {
  return (
    <dl className="deflist">
      {items.map((item) => (
        <div className="deflist__row" key={item.label}>
          <dt className="deflist__label">{item.label}</dt>
          <dd className={`deflist__value${item.mono ? ' mono' : ''}${item.muted ? ' is-muted' : ''}`}>
            {item.value === null || item.value === undefined || item.value === '' ? (
              <span className="is-muted">-</span>
            ) : (
              item.value
            )}
            {item.hint ? <span className="deflist__hint">{item.hint}</span> : null}
          </dd>
        </div>
      ))}
    </dl>
  );
}
